import { Component, OnInit } from '@angular/core';
import { HeaderPictureQuery } from '../../../../shared/state/header-picture/header-picture.query';
import { HeaderBackgroundQuery } from '../../../../shared/state/header-background/header-background.query';
import { HeaderIconQuery } from '../../../../shared/state/header-icon/header-icon.query';
import { LibraryService } from '../../../../core/services/library/library.service';
import { CompanyQuery } from '../../../../shared/state/company/company.query';
import { ToastService } from '../../../../core/services/toast/toast.service';
import { UserQuery } from '../../../../shared/state/user/user.query';
import { filter, take } from 'rxjs/operators';
import { UserService } from '../../../../shared/state/user/user.service';
import { Observable } from 'rxjs';
import { UserReferrerData } from '../../../../shared/models/userReferrerData';
import { ViewDidEnter, ViewWillEnter } from '@ionic/angular';
import { Clipboard } from '@capacitor/clipboard';
import { Share } from '@capacitor/share';


@Component({
    selector: 'app-friend-program',
    templateUrl: './friend-program.component.html',
    styleUrls: ['./friend-program.component.scss'],
})
export class FriendProgramComponent implements OnInit, ViewDidEnter {
    headerPicture$;
    headerBackground$;
    headerIcon$;
    referrerData$: Observable<UserReferrerData>;

    isMac: boolean;
    isChrome: boolean;
    isFirefox: boolean;

    constructor(
        private companyQuery: CompanyQuery,
        private headerPictureQuery: HeaderPictureQuery,
        private headerBackgroundQuery: HeaderBackgroundQuery,
        private headerIconQuery: HeaderIconQuery,
        private libraryService: LibraryService,
        private toastService: ToastService,
        private userQuery: UserQuery,
        private userService: UserService
    ) {}

    ngOnInit(): void {
        this.headerPicture$ = this.headerPictureQuery.select('account');
        this.headerBackground$ = this.headerBackgroundQuery.select('account');
        this.headerIcon$ = this.headerIconQuery.select('account');
        this.referrerData$ = this.userQuery.select('referrer');

        this.isMac = navigator.platform.indexOf('Mac') > -1;
        this.isChrome = /Google Inc/.test(navigator.vendor);
        this.isFirefox = /Firefox/.test(navigator.userAgent);
    }

    ionViewDidEnter() {
        if (!this.userQuery.advisorCode || this.userQuery.advisorCode === '') {
            this.userQuery
                .select()
                .pipe(
                    filter(({ tokenId }) => tokenId !== ''),
                    take(1)
                )
                .subscribe(async () => {
                    await this.getReferrerData();
                });
        }
    }

    async share(url: string): Promise<void> {
        const canShare =  (await Share.canShare()).value;
        if(canShare){
            Share.share({
                title: this.libraryService.getLabel('app_share_title'),
                text: this.userQuery.advisorShareText,
                url,
                dialogTitle: this.libraryService.getLabel('app_share_dialog_title'),
            });
        }else{
            this.toastService.presentErrorToast(
                this.libraryService.getLabel('lbl_share_not_enabled')
            );
        }
    }

    async refreshReferrerData(event) {
        await this.getReferrerData();
        event.target.complete();
    }

    async copy(code: string): Promise<void> {
        try {
            await Clipboard.write({
                string: code,
            });
            await this.toastService.presentInfoToast(
                this.libraryService.getLabel('app_copy_success')
            );
        } catch (e) {
            await this.toastService.presentErrorToast(
                this.libraryService.getLabel('app_copy_error')
            );
        }
    }

    private async getReferrerData(): Promise<void> {
        await this.userService.getReferrerData();
    }
}
